import { render, staticRenderFns } from "./DescuentosAbonados.vue?vue&type=template&id=4f9499c6"
import script from "./DescuentosAbonados.vue?vue&type=script&lang=js"
export * from "./DescuentosAbonados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports